// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/shared.module.css */

/* ⭐ NEW: badge indicating a chain node has parallel actions attached.
   Used by CanvasView on the node card header. Presentational only —
   editing the post-triggers happens in the list view's detail pane. */
.shared_postTriggerBadge__wOORr {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  font-weight: 600;
  color: #2c5282;
  background: #ebf0ff;
  border: 1px solid #bee3f8;
  padding: 1px 7px;
  border-radius: 10px;
  margin-left: 6px;
  line-height: 1.4;
}

.shared_postTriggerBadge__wOORr svg {
  color: #5b7cfa;
}

/* shared.module.css
   Classes used by BOTH ChainApis.jsx and CanvasView.jsx.
   Import as: import shared from "./shared.module.css"; */

/* ── Stage icons ─────────────────────────────────────────── */
.shared_treeRowStageIcon__c3RkI {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 11px;
  line-height: 1;
}

.shared_treeRowStageIcon__c3RkI.shared_empty__Vw9VS {
  color: #c5221f;
  background: #fce8e6;
  border: 1px solid #f5b5b0;
}

.shared_treeRowStageIcon__c3RkI.shared_needsMap__V667n {
  color: #9a5b00;
  background: #fff2e0;
  border: 1px solid #ffd9a8;
}

.shared_treeRowStageIcon__c3RkI.shared_done__0JFIH {
  color: #1e7e34;
  background: #e6f4ea;
  border: 1px solid #b7e1c0;
}

.shared_treeRowStageIcon__c3RkI.shared_manual__OHcOf {
  color: #744210;
  background: #fefcbf;
  border: 1px solid #f6ad55;
}

.shared_treeLegendIcon__hikr0 { margin-right: 2px; }

/* ── Status pill (used in tree rows + canvas cards + step rail) ── */
.shared_treeRowStatusPill__q8OQ3 {
  flex: 0 0 auto;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 10.5px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 4px;
  background: #edf2f7;
  color: #4a5568;
}

.shared_treeRowStatusPill__q8OQ3.shared_s2xx__lc0ua    { background: #e6f4ea; color: #1e7e34; }
.shared_treeRowStatusPill__q8OQ3.shared_s3xx__v1hbP    { background: #e8f0fe; color: #1a4fa0; }
.shared_treeRowStatusPill__q8OQ3.shared_s4xx__iEs6S    { background: #fff2e0; color: #9a5b00; }
.shared_treeRowStatusPill__q8OQ3.shared_s5xx__O27-7    { background: #fce8e6; color: #c5221f; }
.shared_treeRowStatusPill__q8OQ3.shared_sDefault__BiWE6 { background: #fefcbf; color: #744210; }

/* ── Method chip ── */
.shared_treeRowMethod__yd-Jq {
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #1a73e8;
  background: #e8f0fe;
  padding: 1px 5px;
  border-radius: 3px;
  text-transform: uppercase;
}

/* ── Manual badge (canvas + list) ── */
.shared_manualBadge__YqvDm {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 600;
  color: #744210;
  background: #fefcbf;
  border: 1px solid #f6ad55;
  border-radius: 10px;
  vertical-align: middle;
}

.shared_treeRowManualDot__eH0xn {
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 700;
  color: #744210;
  background: #fefcbf;
  border: 1px solid #f6ad55;
  border-radius: 10px;
  padding: 1px 6px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.shared_treeRowManualInline__QC5zu {
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 700;
  color: #744210;
  background: #fefcbf;
  border: 1px solid #f6ad55;
  border-radius: 10px;
  padding: 1px 6px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 2px;
}

/* ── Manual toggle (canvas node) ── */
.shared_canvasManualToggle__hperN {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 8px 10px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.shared_canvasManualToggle__hperN input { margin: 0; cursor: pointer; }
.shared_canvasManualToggle__hperN:hover { background: #edf2f7; }

.shared_canvasManualHint__N-v1S {
  margin-top: 6px;
  padding: 8px 10px;
  background: #fff8e1;
  border: 1px solid #ffd54f;
  border-radius: 4px;
  font-size: 11px;
  color: #5d4037;
  line-height: 1.5;
}

.shared_canvasManualHint__N-v1S code {
  background: #ffffff88;
  padding: 1px 4px;
  border-radius: 3px;
  font-family: monospace;
  font-size: 10px;
}

/* ── Progress strip (both editors) ── */
.shared_progressStrip__dIvIK {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 16px;
  background: #f7fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 12px;
  color: #4a5568;
}

.shared_progressPass__SudpX { display: inline-flex; align-items: center; gap: 8px; }
.shared_progressPassLabel__n6pop { font-weight: 600; color: #2d3748; }

.shared_progressPassCount__mVhHS {
  font-family: "SF Mono", Menlo, Consolas, monospace;
  padding: 2px 8px;
  border-radius: 10px;
  background: #edf2f7;
  color: #4a5568;
  font-size: 11px;
  font-weight: 600;
}

.shared_progressPassCount__mVhHS.shared_done__0JFIH    { background: #e6f4ea; color: #1e7e34; }
.shared_progressPassCount__mVhHS.shared_partial__YkSnC { background: #fff8e1; color: #8a6d00; border: 1px solid #ffe082; }
.shared_progressPassCount__mVhHS.shared_pending__p0HA2 { background: #fce8e6; color: #c5221f; }

.shared_progressDivider__ZaUoi { color: #cbd5e0; }

.shared_progressHint__buZf\\+ {
  margin-left: auto;
  font-size: 12px;
  color: #718096;
  font-style: italic;
}

/* ── Step rail (canvas, but harmless if list wants it too) ── */
.shared_stepRail__8E5ku {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 10px 16px;
  background: #fff;
  border-bottom: 1px solid #edf2f7;
  font-size: 12px;
}

.shared_stepRailSep__nhYlR { color: #cbd5e0; font-size: 11px; }

.shared_stepRailPill__O19Lf {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  font-size: 11.5px;
  color: #4a5568;
  transition: all 0.15s ease;
}

.shared_stepRailPill__O19Lf:hover { border-color: #93b4e8; background: #f8fbff; }

.shared_stepRailPillActive__p0j7v {
  border-color: #1a73e8;
  background: #e8f0fe;
  color: #1a4fa0;
  font-weight: 600;
}

.shared_stepRailNum__PWn2Y {
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-weight: 700;
  font-size: 10px;
  color: #718096;
}

.shared_stepRailPillActive__p0j7v .shared_stepRailNum__PWn2Y { color: #1a73e8; }

/* ── Focus header ── */
.shared_focusHeader__55Lxa {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: #f7fafc;
  border-bottom: 1px solid #edf2f7;
  font-size: 12.5px;
  color: #4a5568;
}

.shared_focusHeaderStep__LEJiW {
  font-weight: 700;
  color: #1a4fa0;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 11.5px;
}

.shared_focusHeaderLabel__gSVbR { font-weight: 600; color: #2d3748; }

.shared_focusHeaderUrl__c4Oy4 {
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 12px;
  color: #2d3748;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 40ch;
  cursor: help;
}

.shared_focusHeaderNext__AJi2N {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #1a73e8;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
}

.shared_focusHeaderNext__AJi2N:hover { background: #1557b0; }

/* ── Next-step CTA bars ── */
.shared_edgeNextBar__veONU {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
  padding: 12px 14px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.shared_edgeNextLabel__9\\+i7K { font-size: 12.5px; color: #4a5568; }

.shared_edgeNextBtn__FTeqn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  background: #1a73e8;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
}

.shared_edgeNextBtn__FTeqn:hover { background: #1557b0; }
.shared_edgeNextBtn__FTeqn:disabled { background: #cbd5e0; cursor: not-allowed; }

.shared_nodeNextBar__9IAF3 {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #ebf8ff;
  border: 1px solid #bee3f8;
  margin-top: 14px;
  font-size: 12.5px;
  color: #2a4365;
}

.shared_nodeNextBar__9IAF3.shared_warn__nJRSg { background: #fff8e1; border-color: #ffe082; color: #744210; }

.shared_nodeNextBtn__p9\\+NP {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #1a73e8;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.shared_nodeNextBtn__p9\\+NP:hover { background: #1557b0; }

/* ── Info callout ── */
.shared_infoCallout__IPSsj {
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12.5px;
  line-height: 1.5;
  margin-bottom: 12px;
}

.shared_infoCallout__IPSsj.shared_info__25bv6 { background: #ebf8ff; border: 1px solid #bee3f8; color: #2a4365; }
.shared_infoCallout__IPSsj.shared_warn__nJRSg { background: #fff8e1; border: 1px solid #ffe082; color: #744210; }
.shared_infoCalloutIcon__cfR-R { flex: 0 0 auto; margin-top: 1px; }

/* ── Badges ── */
.shared_enabledBadge__VNpah {
  display: inline-block;
  padding: 2px 10px;
  background: #e6f4ea;
  color: #1e7e34;
  font-size: 12px;
  font-weight: 600;
  border-radius: 12px;
}

.shared_disabledBadge__Z-Mzp {
  display: inline-block;
  padding: 2px 10px;
  background: #fce8e6;
  color: #d93025;
  font-size: 12px;
  font-weight: 600;
  border-radius: 12px;
  text-align: center;
}

.shared_workflowBadge__IUuWR {
  display: inline-block;
  padding: 2px 10px;
  background: #e8f0fe;
  color: #1a73e8;
  font-size: 11px;
  font-weight: 600;
  border-radius: 12px;
  text-transform: uppercase;
  text-align: center;
}

/* ── Node card innards (both editors share these) ── */
.shared_canvasNodeUrl__VmyWF {
  font-size: 13px;
  color: #333;
  font-weight: 500;
  margin-bottom: 8px;
  word-break: break-all;
}

.shared_canvasNodeMethod__8NnC2 {
  display: inline-block;
  padding: 2px 10px;
  background: #e8f0fe;
  color: #1a73e8;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  text-transform: uppercase;
}

.shared_canvasNodeLabel__Xm-sl { font-size: 14px; font-weight: 600; color: #1a1a2e; }
.shared_canvasNodeSub__TR-xc   { font-size: 12px; color: #666; margin-top: 4px; }

.shared_canvasNodeMeta__6zTIn {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e8e8e8;
}

.shared_canvasNodeMeta__6zTIn > span {
  font-size: 12px;
  color: #666;
  display: block;
  margin-bottom: 4px;
}

.shared_canvasNodeDataList__vr6tP {
  margin: 4px 0 0 0;
  padding-left: 0;
  list-style: none;
  font-size: 12px;
  color: #555;
}

.shared_canvasNodeDataList__vr6tP li {
  margin: 2px 0;
  padding: 2px 8px;
  background: #f0f4ff;
  border-radius: 4px;
  font-family: monospace;
  font-size: 11px;
}

.shared_canvasNodeEmptyData__5R-ZI { font-size: 12px; color: #999; font-style: italic; }

.shared_startIcon__BuMpB { color: #34a853; font-size: 16px; margin-right: 8px; }
.shared_canvasArrow__arJff { flex: 0 0 auto; color: #ccc; font-size: 20px; align-self: center; }

/* ── Shared form controls ── */
.shared_canvasNameInput__MYNKp {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
  border: 2px solid transparent;
  background: transparent;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s;
  min-width: 200px;
}

.shared_canvasNameInput__MYNKp:hover { border-color: #e8e8e8; background: white; }

.shared_canvasNameInput__MYNKp:focus {
  outline: none;
  border-color: #1a73e8;
  background: white;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.shared_canvasToggle__od1Gb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.shared_canvasToggle__od1Gb input[type="checkbox"] {
  width: 40px;
  height: 22px;
  appearance: none;
  background: #ccc;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}

.shared_canvasToggle__od1Gb input[type="checkbox"]:checked { background: #34a853; }

.shared_canvasToggle__od1Gb input[type="checkbox"]::before {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  top: 2px;
  left: 2px;
  transition: transform 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.shared_canvasToggle__od1Gb input[type="checkbox"]:checked::before { transform: translateX(18px); }

.shared_canvasSelect__FN-Gs {
  padding: 6px 32px 6px 12px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  font-size: 12px;
  background: white;
  color: #333;
  cursor: pointer;
  appearance: none;
  min-width: 180px;
  transition: all 0.2s;
  width: 100%;
}

.shared_canvasSelect__FN-Gs:hover { border-color: #1a73e8; }

.shared_canvasSelect__FN-Gs:focus {
  outline: none;
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.shared_selectWrapper__4IYOr { position: relative; display: flex; align-items: center; }

.shared_selectIcon__H66b5 {
  position: absolute;
  right: 10px;
  pointer-events: none;
  color: #888;
}

/* ── Buttons ── */
.shared_saveButton__al518 {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #1a73e8;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.shared_saveButton__al518:hover {
  background: #1557b0;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);
}

.shared_cancelButton__SXKDc {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #f1f3f4;
  color: #5f6368;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.shared_cancelButton__SXKDc:hover { background: #e8eaed; }

.shared_deleteBranchBtn__bX-Be {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: transparent;
  border: none;
  color: #999;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  margin-left: auto;
  margin-right: 0.5rem;
}

.shared_deleteBranchBtn__bX-Be:hover { background: #fce8e6; color: #d93025; }

.shared_editButton__8OdB8 {
  width: 40px;
  height: 40px;
  background: #1a73e8;
  color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
}

.shared_editButton__8OdB8:hover { background: #1557b0; }

.shared_deleteButton__mBvMo {
  width: 40px;
  height: 40px;
  background: #ea4335;
  color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
}

.shared_deleteButton__mBvMo:hover { background: #d93025; }

.shared_iconBtn__AGVZE {
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: transparent;
  margin-right: 3px;
}

/* ── Canvas card atoms shared between both editors ── */
.shared_canvasCard2__Hsx8T {
  flex: 0 0 auto;
  min-width: 260px;
  max-width: 300px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
  cursor: pointer;
}

.shared_canvasCard2__Hsx8T:hover {
  border-color: #93b4e8;
  box-shadow: 0 4px 16px rgba(26, 115, 232, 0.08);
}

.shared_canvasCard2Focused__cZqfl {
  border-color: #1a73e8;
  box-shadow:
    0 0 0 2px rgba(26, 115, 232, 0.18),
    0 4px 16px rgba(26, 115, 232, 0.1);
}

.shared_canvasCard2Manual__XmtfE { border-color: #f6ad55; background: #fffaf0; }

.shared_canvasCard2Empty__qyCFG {
  border-style: dashed;
  border-color: #cbd5e0;
  background: #fafafa;
}

.shared_canvasCard2Header__7Ye2t {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.shared_canvasCard2Title__6YQHy {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  min-width: 0;
}

.shared_firstStepHint__vujaX {
  font-size: 0.85rem;
  color: #888;
  font-style: italic;
  margin: 0.5rem 0 0;
}

@media (max-width: 900px) {
  .shared_canvasCard2__Hsx8T { min-width: 220px; max-width: 240px; }
  .shared_focusHeaderNext__AJi2N { display: none; }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/shared.module.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;;sEAEsE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;yDAEyD;;AAEzD,+DAA+D;AAC/D;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gCAAkB,iBAAiB,EAAE;;AAErC,qEAAqE;AACrE;EACE,cAAc;EACd,kDAAkD;EAClD,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yDAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,yDAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,yDAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,yDAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,0DAA8B,mBAAmB,EAAE,cAAc,EAAE;;AAEnE,sBAAsB;AACtB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,0CAA4B,SAAS,EAAE,eAAe,EAAE;AACxD,0CAA4B,mBAAmB,EAAE;;AAEjD;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA,8BAAgB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACrE,mCAAqB,gBAAgB,EAAE,cAAc,EAAE;;AAEvD;EACE,kDAAkD;EAClD,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,yDAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,yDAA6B,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC7F,yDAA6B,mBAAmB,EAAE,cAAc,EAAE;;AAElE,iCAAmB,cAAc,EAAE;;AAEnC;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA,6BAAe,cAAc,EAAE,eAAe,EAAE;;AAEhD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,oCAAsB,qBAAqB,EAAE,mBAAmB,EAAE;;AAElE;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,+DAAmC,cAAc,EAAE;;AAEnD,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA,kCAAoB,gBAAgB,EAAE,cAAc,EAAE;;AAEtD;EACE,kDAAkD;EAClD,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uCAAyB,mBAAmB,EAAE;;AAE9C,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,gCAAiB,iBAAiB,EAAE,cAAc,EAAE;;AAEpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mCAAqB,mBAAmB,EAAE;AAC1C,sCAAwB,mBAAmB,EAAE,mBAAmB,EAAE;;AAElE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gDAAoB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAEhF;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oCAAqB,mBAAmB,EAAE;;AAE1C,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gDAAoB,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AACpF,gDAAoB,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AACpF,iCAAmB,cAAc,EAAE,eAAe,EAAE;;AAEpD,iBAAiB;AACjB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,iCAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtE,iCAAmB,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;;AAElE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,qCAAuB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE;;AAEzE,2BAAa,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE;AACjE,6BAAe,cAAc,EAAE,WAAW,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAEjF,+BAA+B;AAC/B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,uCAAyB,qBAAqB,EAAE,iBAAiB,EAAE;;AAEnE;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,6DAA+C,mBAAmB,EAAE;;AAEpE;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,qEAAuD,2BAA2B,EAAE;;AAEpF;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA,oCAAsB,qBAAqB,EAAE;;AAE7C;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,+BAAiB,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;;AAEzE;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA,oCAAsB,mBAAmB,EAAE;;AAE3C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,uCAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,kCAAoB,mBAAmB,EAAE;;AAEzC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,oCAAsB,mBAAmB,EAAE;;AAE3C;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,wDAAwD;AACxD;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB;;sCAEoC;AACtC;;AAEA,mCAAqB,qBAAqB,EAAE,mBAAmB,EAAE;;AAEjE;EACE,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAAe,gBAAgB,EAAE,gBAAgB,EAAE;EACnD,iCAAmB,aAAa,EAAE;AACpC","sourcesContent":["/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/shared.module.css */\n\n/* ⭐ NEW: badge indicating a chain node has parallel actions attached.\n   Used by CanvasView on the node card header. Presentational only —\n   editing the post-triggers happens in the list view's detail pane. */\n.postTriggerBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #2c5282;\n  background: #ebf0ff;\n  border: 1px solid #bee3f8;\n  padding: 1px 7px;\n  border-radius: 10px;\n  margin-left: 6px;\n  line-height: 1.4;\n}\n\n.postTriggerBadge svg {\n  color: #5b7cfa;\n}\n\n/* shared.module.css\n   Classes used by BOTH ChainApis.jsx and CanvasView.jsx.\n   Import as: import shared from \"./shared.module.css\"; */\n\n/* ── Stage icons ─────────────────────────────────────────── */\n.treeRowStageIcon {\n  flex: 0 0 auto;\n  width: 16px;\n  height: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 11px;\n  line-height: 1;\n}\n\n.treeRowStageIcon.empty {\n  color: #c5221f;\n  background: #fce8e6;\n  border: 1px solid #f5b5b0;\n}\n\n.treeRowStageIcon.needsMap {\n  color: #9a5b00;\n  background: #fff2e0;\n  border: 1px solid #ffd9a8;\n}\n\n.treeRowStageIcon.done {\n  color: #1e7e34;\n  background: #e6f4ea;\n  border: 1px solid #b7e1c0;\n}\n\n.treeRowStageIcon.manual {\n  color: #744210;\n  background: #fefcbf;\n  border: 1px solid #f6ad55;\n}\n\n.treeLegendIcon { margin-right: 2px; }\n\n/* ── Status pill (used in tree rows + canvas cards + step rail) ── */\n.treeRowStatusPill {\n  flex: 0 0 auto;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 10.5px;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 4px;\n  background: #edf2f7;\n  color: #4a5568;\n}\n\n.treeRowStatusPill.s2xx    { background: #e6f4ea; color: #1e7e34; }\n.treeRowStatusPill.s3xx    { background: #e8f0fe; color: #1a4fa0; }\n.treeRowStatusPill.s4xx    { background: #fff2e0; color: #9a5b00; }\n.treeRowStatusPill.s5xx    { background: #fce8e6; color: #c5221f; }\n.treeRowStatusPill.sDefault { background: #fefcbf; color: #744210; }\n\n/* ── Method chip ── */\n.treeRowMethod {\n  flex: 0 0 auto;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  color: #1a73e8;\n  background: #e8f0fe;\n  padding: 1px 5px;\n  border-radius: 3px;\n  text-transform: uppercase;\n}\n\n/* ── Manual badge (canvas + list) ── */\n.manualBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 8px;\n  padding: 2px 8px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #744210;\n  background: #fefcbf;\n  border: 1px solid #f6ad55;\n  border-radius: 10px;\n  vertical-align: middle;\n}\n\n.treeRowManualDot {\n  flex: 0 0 auto;\n  font-size: 10px;\n  font-weight: 700;\n  color: #744210;\n  background: #fefcbf;\n  border: 1px solid #f6ad55;\n  border-radius: 10px;\n  padding: 1px 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.treeRowManualInline {\n  flex: 0 0 auto;\n  font-size: 10px;\n  font-weight: 700;\n  color: #744210;\n  background: #fefcbf;\n  border: 1px solid #f6ad55;\n  border-radius: 10px;\n  padding: 1px 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  margin-left: 2px;\n}\n\n/* ── Manual toggle (canvas node) ── */\n.canvasManualToggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n  padding: 8px 10px;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.canvasManualToggle input { margin: 0; cursor: pointer; }\n.canvasManualToggle:hover { background: #edf2f7; }\n\n.canvasManualHint {\n  margin-top: 6px;\n  padding: 8px 10px;\n  background: #fff8e1;\n  border: 1px solid #ffd54f;\n  border-radius: 4px;\n  font-size: 11px;\n  color: #5d4037;\n  line-height: 1.5;\n}\n\n.canvasManualHint code {\n  background: #ffffff88;\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-family: monospace;\n  font-size: 10px;\n}\n\n/* ── Progress strip (both editors) ── */\n.progressStrip {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 10px 16px;\n  background: #f7fafc;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 12px;\n  color: #4a5568;\n}\n\n.progressPass { display: inline-flex; align-items: center; gap: 8px; }\n.progressPassLabel { font-weight: 600; color: #2d3748; }\n\n.progressPassCount {\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: #edf2f7;\n  color: #4a5568;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.progressPassCount.done    { background: #e6f4ea; color: #1e7e34; }\n.progressPassCount.partial { background: #fff8e1; color: #8a6d00; border: 1px solid #ffe082; }\n.progressPassCount.pending { background: #fce8e6; color: #c5221f; }\n\n.progressDivider { color: #cbd5e0; }\n\n.progressHint {\n  margin-left: auto;\n  font-size: 12px;\n  color: #718096;\n  font-style: italic;\n}\n\n/* ── Step rail (canvas, but harmless if list wants it too) ── */\n.stepRail {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 10px 16px;\n  background: #fff;\n  border-bottom: 1px solid #edf2f7;\n  font-size: 12px;\n}\n\n.stepRailSep { color: #cbd5e0; font-size: 11px; }\n\n.stepRailPill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 11.5px;\n  color: #4a5568;\n  transition: all 0.15s ease;\n}\n\n.stepRailPill:hover { border-color: #93b4e8; background: #f8fbff; }\n\n.stepRailPillActive {\n  border-color: #1a73e8;\n  background: #e8f0fe;\n  color: #1a4fa0;\n  font-weight: 600;\n}\n\n.stepRailNum {\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-weight: 700;\n  font-size: 10px;\n  color: #718096;\n}\n\n.stepRailPillActive .stepRailNum { color: #1a73e8; }\n\n/* ── Focus header ── */\n.focusHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  background: #f7fafc;\n  border-bottom: 1px solid #edf2f7;\n  font-size: 12.5px;\n  color: #4a5568;\n}\n\n.focusHeaderStep {\n  font-weight: 700;\n  color: #1a4fa0;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 11.5px;\n}\n\n.focusHeaderLabel { font-weight: 600; color: #2d3748; }\n\n.focusHeaderUrl {\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 12px;\n  color: #2d3748;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 40ch;\n  cursor: help;\n}\n\n.focusHeaderNext {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #1a73e8;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.focusHeaderNext:hover { background: #1557b0; }\n\n/* ── Next-step CTA bars ── */\n.edgeNextBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 18px;\n  padding: 12px 14px;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.edgeNextLabel { font-size: 12.5px; color: #4a5568; }\n\n.edgeNextBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  background: #1a73e8;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.edgeNextBtn:hover { background: #1557b0; }\n.edgeNextBtn:disabled { background: #cbd5e0; cursor: not-allowed; }\n\n.nodeNextBar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #ebf8ff;\n  border: 1px solid #bee3f8;\n  margin-top: 14px;\n  font-size: 12.5px;\n  color: #2a4365;\n}\n\n.nodeNextBar.warn { background: #fff8e1; border-color: #ffe082; color: #744210; }\n\n.nodeNextBtn {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #1a73e8;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.nodeNextBtn:hover { background: #1557b0; }\n\n/* ── Info callout ── */\n.infoCallout {\n  display: flex;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  margin-bottom: 12px;\n}\n\n.infoCallout.info { background: #ebf8ff; border: 1px solid #bee3f8; color: #2a4365; }\n.infoCallout.warn { background: #fff8e1; border: 1px solid #ffe082; color: #744210; }\n.infoCalloutIcon { flex: 0 0 auto; margin-top: 1px; }\n\n/* ── Badges ── */\n.enabledBadge {\n  display: inline-block;\n  padding: 2px 10px;\n  background: #e6f4ea;\n  color: #1e7e34;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 12px;\n}\n\n.disabledBadge {\n  display: inline-block;\n  padding: 2px 10px;\n  background: #fce8e6;\n  color: #d93025;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 12px;\n  text-align: center;\n}\n\n.workflowBadge {\n  display: inline-block;\n  padding: 2px 10px;\n  background: #e8f0fe;\n  color: #1a73e8;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 12px;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n/* ── Node card innards (both editors share these) ── */\n.canvasNodeUrl {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n  margin-bottom: 8px;\n  word-break: break-all;\n}\n\n.canvasNodeMethod {\n  display: inline-block;\n  padding: 2px 10px;\n  background: #e8f0fe;\n  color: #1a73e8;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n\n.canvasNodeLabel { font-size: 14px; font-weight: 600; color: #1a1a2e; }\n.canvasNodeSub   { font-size: 12px; color: #666; margin-top: 4px; }\n\n.canvasNodeMeta {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #e8e8e8;\n}\n\n.canvasNodeMeta > span {\n  font-size: 12px;\n  color: #666;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.canvasNodeDataList {\n  margin: 4px 0 0 0;\n  padding-left: 0;\n  list-style: none;\n  font-size: 12px;\n  color: #555;\n}\n\n.canvasNodeDataList li {\n  margin: 2px 0;\n  padding: 2px 8px;\n  background: #f0f4ff;\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.canvasNodeEmptyData { font-size: 12px; color: #999; font-style: italic; }\n\n.startIcon { color: #34a853; font-size: 16px; margin-right: 8px; }\n.canvasArrow { flex: 0 0 auto; color: #ccc; font-size: 20px; align-self: center; }\n\n/* ── Shared form controls ── */\n.canvasNameInput {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a1a2e;\n  border: 2px solid transparent;\n  background: transparent;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all 0.2s;\n  min-width: 200px;\n}\n\n.canvasNameInput:hover { border-color: #e8e8e8; background: white; }\n\n.canvasNameInput:focus {\n  outline: none;\n  border-color: #1a73e8;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.canvasToggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n}\n\n.canvasToggle input[type=\"checkbox\"] {\n  width: 40px;\n  height: 22px;\n  appearance: none;\n  background: #ccc;\n  border-radius: 12px;\n  position: relative;\n  cursor: pointer;\n  transition: background 0.2s;\n  flex-shrink: 0;\n}\n\n.canvasToggle input[type=\"checkbox\"]:checked { background: #34a853; }\n\n.canvasToggle input[type=\"checkbox\"]::before {\n  content: \"\";\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  background: white;\n  border-radius: 50%;\n  top: 2px;\n  left: 2px;\n  transition: transform 0.2s;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.canvasToggle input[type=\"checkbox\"]:checked::before { transform: translateX(18px); }\n\n.canvasSelect {\n  padding: 6px 32px 6px 12px;\n  border: 1px solid #d0d0d0;\n  border-radius: 6px;\n  font-size: 12px;\n  background: white;\n  color: #333;\n  cursor: pointer;\n  appearance: none;\n  min-width: 180px;\n  transition: all 0.2s;\n  width: 100%;\n}\n\n.canvasSelect:hover { border-color: #1a73e8; }\n\n.canvasSelect:focus {\n  outline: none;\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.selectWrapper { position: relative; display: flex; align-items: center; }\n\n.selectIcon {\n  position: absolute;\n  right: 10px;\n  pointer-events: none;\n  color: #888;\n}\n\n/* ── Buttons ── */\n.saveButton {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: #1a73e8;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.saveButton:hover {\n  background: #1557b0;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);\n}\n\n.cancelButton {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: #f1f3f4;\n  color: #5f6368;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cancelButton:hover { background: #e8eaed; }\n\n.deleteBranchBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  background: transparent;\n  border: none;\n  color: #999;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s;\n  margin-left: auto;\n  margin-right: 0.5rem;\n}\n\n.deleteBranchBtn:hover { background: #fce8e6; color: #d93025; }\n\n.editButton {\n  width: 40px;\n  height: 40px;\n  background: #1a73e8;\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.editButton:hover { background: #1557b0; }\n\n.deleteButton {\n  width: 40px;\n  height: 40px;\n  background: #ea4335;\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.deleteButton:hover { background: #d93025; }\n\n.iconBtn {\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-color: transparent;\n  margin-right: 3px;\n}\n\n/* ── Canvas card atoms shared between both editors ── */\n.canvasCard2 {\n  flex: 0 0 auto;\n  min-width: 260px;\n  max-width: 300px;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  padding: 14px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.canvasCard2:hover {\n  border-color: #93b4e8;\n  box-shadow: 0 4px 16px rgba(26, 115, 232, 0.08);\n}\n\n.canvasCard2Focused {\n  border-color: #1a73e8;\n  box-shadow:\n    0 0 0 2px rgba(26, 115, 232, 0.18),\n    0 4px 16px rgba(26, 115, 232, 0.1);\n}\n\n.canvasCard2Manual { border-color: #f6ad55; background: #fffaf0; }\n\n.canvasCard2Empty {\n  border-style: dashed;\n  border-color: #cbd5e0;\n  background: #fafafa;\n}\n\n.canvasCard2Header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.canvasCard2Title {\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a2e;\n  min-width: 0;\n}\n\n.firstStepHint {\n  font-size: 0.85rem;\n  color: #888;\n  font-style: italic;\n  margin: 0.5rem 0 0;\n}\n\n@media (max-width: 900px) {\n  .canvasCard2 { min-width: 220px; max-width: 240px; }\n  .focusHeaderNext { display: none; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"postTriggerBadge": `shared_postTriggerBadge__wOORr`,
	"treeRowStageIcon": `shared_treeRowStageIcon__c3RkI`,
	"empty": `shared_empty__Vw9VS`,
	"needsMap": `shared_needsMap__V667n`,
	"done": `shared_done__0JFIH`,
	"manual": `shared_manual__OHcOf`,
	"treeLegendIcon": `shared_treeLegendIcon__hikr0`,
	"treeRowStatusPill": `shared_treeRowStatusPill__q8OQ3`,
	"s2xx": `shared_s2xx__lc0ua`,
	"s3xx": `shared_s3xx__v1hbP`,
	"s4xx": `shared_s4xx__iEs6S`,
	"s5xx": `shared_s5xx__O27-7`,
	"sDefault": `shared_sDefault__BiWE6`,
	"treeRowMethod": `shared_treeRowMethod__yd-Jq`,
	"manualBadge": `shared_manualBadge__YqvDm`,
	"treeRowManualDot": `shared_treeRowManualDot__eH0xn`,
	"treeRowManualInline": `shared_treeRowManualInline__QC5zu`,
	"canvasManualToggle": `shared_canvasManualToggle__hperN`,
	"canvasManualHint": `shared_canvasManualHint__N-v1S`,
	"progressStrip": `shared_progressStrip__dIvIK`,
	"progressPass": `shared_progressPass__SudpX`,
	"progressPassLabel": `shared_progressPassLabel__n6pop`,
	"progressPassCount": `shared_progressPassCount__mVhHS`,
	"partial": `shared_partial__YkSnC`,
	"pending": `shared_pending__p0HA2`,
	"progressDivider": `shared_progressDivider__ZaUoi`,
	"progressHint": `shared_progressHint__buZf+`,
	"stepRail": `shared_stepRail__8E5ku`,
	"stepRailSep": `shared_stepRailSep__nhYlR`,
	"stepRailPill": `shared_stepRailPill__O19Lf`,
	"stepRailPillActive": `shared_stepRailPillActive__p0j7v`,
	"stepRailNum": `shared_stepRailNum__PWn2Y`,
	"focusHeader": `shared_focusHeader__55Lxa`,
	"focusHeaderStep": `shared_focusHeaderStep__LEJiW`,
	"focusHeaderLabel": `shared_focusHeaderLabel__gSVbR`,
	"focusHeaderUrl": `shared_focusHeaderUrl__c4Oy4`,
	"focusHeaderNext": `shared_focusHeaderNext__AJi2N`,
	"edgeNextBar": `shared_edgeNextBar__veONU`,
	"edgeNextLabel": `shared_edgeNextLabel__9+i7K`,
	"edgeNextBtn": `shared_edgeNextBtn__FTeqn`,
	"nodeNextBar": `shared_nodeNextBar__9IAF3`,
	"warn": `shared_warn__nJRSg`,
	"nodeNextBtn": `shared_nodeNextBtn__p9+NP`,
	"infoCallout": `shared_infoCallout__IPSsj`,
	"info": `shared_info__25bv6`,
	"infoCalloutIcon": `shared_infoCalloutIcon__cfR-R`,
	"enabledBadge": `shared_enabledBadge__VNpah`,
	"disabledBadge": `shared_disabledBadge__Z-Mzp`,
	"workflowBadge": `shared_workflowBadge__IUuWR`,
	"canvasNodeUrl": `shared_canvasNodeUrl__VmyWF`,
	"canvasNodeMethod": `shared_canvasNodeMethod__8NnC2`,
	"canvasNodeLabel": `shared_canvasNodeLabel__Xm-sl`,
	"canvasNodeSub": `shared_canvasNodeSub__TR-xc`,
	"canvasNodeMeta": `shared_canvasNodeMeta__6zTIn`,
	"canvasNodeDataList": `shared_canvasNodeDataList__vr6tP`,
	"canvasNodeEmptyData": `shared_canvasNodeEmptyData__5R-ZI`,
	"startIcon": `shared_startIcon__BuMpB`,
	"canvasArrow": `shared_canvasArrow__arJff`,
	"canvasNameInput": `shared_canvasNameInput__MYNKp`,
	"canvasToggle": `shared_canvasToggle__od1Gb`,
	"canvasSelect": `shared_canvasSelect__FN-Gs`,
	"selectWrapper": `shared_selectWrapper__4IYOr`,
	"selectIcon": `shared_selectIcon__H66b5`,
	"saveButton": `shared_saveButton__al518`,
	"cancelButton": `shared_cancelButton__SXKDc`,
	"deleteBranchBtn": `shared_deleteBranchBtn__bX-Be`,
	"editButton": `shared_editButton__8OdB8`,
	"deleteButton": `shared_deleteButton__mBvMo`,
	"iconBtn": `shared_iconBtn__AGVZE`,
	"canvasCard2": `shared_canvasCard2__Hsx8T`,
	"canvasCard2Focused": `shared_canvasCard2Focused__cZqfl`,
	"canvasCard2Manual": `shared_canvasCard2Manual__XmtfE`,
	"canvasCard2Empty": `shared_canvasCard2Empty__qyCFG`,
	"canvasCard2Header": `shared_canvasCard2Header__7Ye2t`,
	"canvasCard2Title": `shared_canvasCard2Title__6YQHy`,
	"firstStepHint": `shared_firstStepHint__vujaX`
};
export default ___CSS_LOADER_EXPORT___;
